import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from '../Loader/Loader';
import * as Styled from './IconButton.styled';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `IconButton` uses SVG as an alternative to the traditional button.
 *
 * The icon can be swapped with another icon. This button cannot be edited or made themable by the admin.
 *
 * Add an `aria-label` to the SVG so screen-reader users can understand the button's purpose.
 */
export const IconButton = ({
  sizePreset = 'md',
  outline = false,
  isLoading = false,
  disabled = false,
  children,
  ...rest
}) => {
  const {
    t
  } = useTranslation('blocks.buttons');
  const renderLoader = () => {
    if (sizePreset === 'md') return /*#__PURE__*/_jsx(Loader, {
      "aria-label": t('IconButton.renderLoader.ariaLoading', 'Loading'),
      circleDiameter: "5px",
      circleSpacing: "9px",
      children: children
    });
    if (sizePreset === 'sm') return /*#__PURE__*/_jsx(Loader, {
      "aria-label": t('IconButton.renderLoader.ariaLoading', 'Loading'),
      circleDiameter: "5px",
      circleSpacing: "7px",
      children: children
    });

    // sizePreset === 'xs
    return /*#__PURE__*/_jsx("span", {
      "aria-label": t('IconButton.renderLoader.ariaLoading', 'Loading'),
      children: children
    });
  };
  return /*#__PURE__*/_jsx(Styled.IconButton, {
    sizePreset: sizePreset,
    outline: outline,
    isLoading: isLoading,
    disabled: disabled || isLoading,
    ...rest,
    children: isLoading ? renderLoader() : children
  });
};